export default "__VITE_ASSET__Doo$9oLh__"